import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { TabContentProp } from "../../../../types/UiKits";
import { dynamicImage } from "../../../../utils";
import { JustifyTabData } from "../../../../data/uiKits/Tabs";
import { Image } from "../../../../coreComponents/Image";

const JustifyTabContent: React.FC<TabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {JustifyTabData &&
        JustifyTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            <div className="designer-details">
              {item.data &&
                item.data.map((item, index) => (
                  <div className="designer-profile" key={index}>
                    <div className="designer-wrap">
                      <Image className="designer-img" src={dynamicImage(item.image)} alt="profile" />
                      <div className="designer-content">
                        <h6>{item.head}</h6>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </TabPane>
        ))}
    </TabContent>
  );
};

export default JustifyTabContent;
